/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FireControllerAssociation model module.
 * @module model/FireControllerAssociation
 * @version 1.1.0
 */
class FireControllerAssociation {
    /**
     * Constructs a new <code>FireControllerAssociation</code>.
     * Object to depict association of user to fire controller
     * @alias module:model/FireControllerAssociation
     * @param userId {String} 
     */
    constructor(userId) { 
        
        FireControllerAssociation.initialize(this, userId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, userId) { 
        obj['userId'] = userId;
    }

    /**
     * Constructs a <code>FireControllerAssociation</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FireControllerAssociation} obj Optional instance to populate.
     * @return {module:model/FireControllerAssociation} The populated <code>FireControllerAssociation</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FireControllerAssociation();

            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
            }
            if (data.hasOwnProperty('fireControllerIds')) {
                obj['fireControllerIds'] = ApiClient.convertToType(data['fireControllerIds'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FireControllerAssociation</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FireControllerAssociation</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of FireControllerAssociation.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['userId'] && !(typeof data['userId'] === 'string' || data['userId'] instanceof String)) {
            throw new Error("Expected the field `userId` to be a primitive type in the JSON string but got " + data['userId']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['fireControllerIds'])) {
            throw new Error("Expected the field `fireControllerIds` to be an array in the JSON data but got " + data['fireControllerIds']);
        }

        return true;
    }


}

FireControllerAssociation.RequiredProperties = ["userId"];

/**
 * @member {String} userId
 */
FireControllerAssociation.prototype['userId'] = undefined;

/**
 * @member {Array.<String>} fireControllerIds
 */
FireControllerAssociation.prototype['fireControllerIds'] = undefined;






export default FireControllerAssociation;

